module.exports = __webpack_public_path__ + "125837252fc558c0bec8b0e8da6a0f72.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/table.jpg
// module id = 187
// module chunks = 0